import './subnav.scss';
import MembershipUtils from './../Membership'

export default function () {
    let $body = $('body');
    let windowWidth = $(window).width();
    let $ratingsSubnavItemsBox = $('.ratings-reliability-box').detach();
    let $ratingMenuItem = $('.sub-tabs li.ratings-tab');
    let $popupWrap = $('#log-in-popup-wrap').clone().attr('id', 'subnav-log-in');
    const ratingsURL = $ratingMenuItem.find('a').attr('href');
    let isVisible = false;
    let $iconLock = $('.subnav-lock-icon');

    $body.append($popupWrap);
    $popupWrap.addClass('subnav-login');

    if($ratingsSubnavItemsBox.length) {
        $body.append($ratingsSubnavItemsBox);

        $ratingsSubnavItemsBox.on('mouseleave', function() {
            $ratingsSubnavItemsBox.hide();
            isVisible = false;
        }).on('mouseenter', function() {
            $ratingsSubnavItemsBox.show();
            isVisible = true;
        });

        $ratingMenuItem.on('mouseover', function() {
            let $this = $(this);
            showRatingsItemsBox($this);
        }).on('mouseleave', function(e) {
            if (!$(e.relatedTarget).closest('.ratings-reliability-box').length) {
                $ratingsSubnavItemsBox.hide();
                isVisible = false;
            }
        }).on('touchstart', function(e) {
            e.preventDefault();

            if(vendor.pageInfo.getLayout() === 'Mobile' || isVisible) {
                window.location.href = ratingsURL;
            }

            let $this = $(this);
            showRatingsItemsBox($this);

            isVisible = true;
        });
    }

    $iconLock.on('mouseover', function() {
        $(this).addClass('subnav-lock-icon-active');
        $popupWrap.show();
        setPopupPosition();
    }).on('mouseleave', function(e) {
        if (!$(e.relatedTarget).closest('#subnav-log-in').length) {
            $(this).removeClass('subnav-lock-icon-active');
            $popupWrap.hide();
        }
    }).on('touchstart', function() {
        $(this).toggleClass('subnav-lock-icon-active');
        $popupWrap.toggle();
        setPopupPosition();
    });

    $popupWrap.on('mouseleave', function() {
        $iconLock.removeClass('subnav-lock-icon-active');
        $popupWrap.hide();
    });

    $('.product-nav').on('touchmove', function() {
        $iconLock.removeClass('subnav-lock-icon-active');
        $popupWrap.hide();
    });

    $('a.sign-in-1').on('click', function() {
        gnav.showSignIn();
    });

    $(window).on('orientationchange', function() {
        $ratingsSubnavItemsBox.hide();
        isVisible = false;
    }).on('scroll', function() {
        if(isVisible) {
            $ratingsSubnavItemsBox.hide();
            isVisible = false;
        }
    }).on('resize', function () {
        windowWidth = $(window).width();
        setPopupPosition();
    });

    function hideLockIcon() {
        if(!MembershipUtils.isPaywallTier()) {
            $iconLock.hide();
        }
    }

    $(document).on('touchstart', function(e) {
        if (!$(e.target).closest('.sub-tabs li.ratings-tab, .ratings-reliability-box').length) {
            $ratingsSubnavItemsBox.hide();
            isVisible = false;
        }

        if (!$(e.target).closest('.subnav-lock-icon, .description-box, #subnav-lock-icon-active').length) {
            $iconLock.removeClass('subnav-lock-icon-active');
            $popupWrap.hide();
        }
    }).on('userInfo_ready ready', function() {
        hideLockIcon();
    });

    hideLockIcon();

    function showRatingsItemsBox($this) {
        const offsetTop = $this.offset().top + $this.outerHeight();
        const offsetLeft = $this.offset().left;

        $ratingsSubnavItemsBox.css({
            'top': offsetTop,
            'left': offsetLeft
        }).show();
    }

    function setPopupPosition() {
        let $iconActive = $('.subnav-lock-icon-active');

        if($iconActive.length) {
            const descriptionWidth = parseInt($('#subnav-log-in .description-box').width());
            const iconActiveOffset = $iconActive.offset();
            const iconHeight =  parseInt($iconActive.css('height'));
            const left = iconActiveOffset.left;

            $popupWrap.removeClass('bottom-right bottom-left');

            if(left + descriptionWidth >= windowWidth) {
                //bottom left
                $popupWrap.addClass('bottom-left');
                $popupWrap.css({
                    'left': `${left - descriptionWidth}px`,
                    'top': `${iconActiveOffset.top + iconHeight}px`
                });
            } else {
                //bottom right
                $popupWrap.addClass('bottom-right');
                $popupWrap.css({
                    'left': `${left}px`,
                    'top': `${iconActiveOffset.top + iconHeight}px`
                });
            }
        } else {
            $popupWrap.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/Subnav/index.js